var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11913",
    "data-name": "Group 11913",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.625,
    height: 23.503,
    viewBox: "0 0 29.625 23.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17041",
    "data-name": "Rectangle 17041",
    width: 29.625,
    height: 23.503,
    fill: "#003883"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11912",
    "data-name": "Group 11912",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37980",
    "data-name": "Path 37980",
    d: "M18.448,18.9H1.88C.548,18.9,0,18.351,0,17.007Q0,9.422,0,1.838C0,.571.571,0,1.837,0H22.668c1.275,0,1.847.566,1.848,1.827q0,4.9,0,9.806v.635a5.68,5.68,0,0,1,4.171,2.517,5.456,5.456,0,0,1,.915,3.591,5.61,5.61,0,0,1-5.027,5.1A5.685,5.685,0,0,1,18.448,18.9m5.044-6.765v-.3q0-5.006,0-10.013c0-.672-.133-.806-.806-.806H1.849c-.7,0-.824.127-.824.838q0,7.305,0,14.61c0,.141.021.281.04.515.174-.21.283-.337.388-.468q3.4-4.246,6.8-8.492a1.057,1.057,0,0,1,1.858.022c.406.525.8,1.056,1.209,1.583.473.617.948,1.233,1.476,1.92.856-.87,1.663-1.695,2.474-2.514.841-.848,1.278-.839,2.067.029,1.133,1.248,2.265,2.5,3.409,3.734.1.113.329.24.443.2.751-.254,1.487-.553,2.305-.866M9.181,8.527,1.713,17.845H16.3L9.181,8.527M20.2,13.741,16.308,9.468l-2.832,2.958c.062.089.152.229.253.361,1.185,1.553,2.388,3.094,3.548,4.666a.9.9,0,0,0,1.1.377A5.8,5.8,0,0,1,20.2,13.741m3.294,2.65v.634c0,1.072,0,2.145,0,3.217,0,.363.088.679.5.685s.522-.3.519-.668c-.005-.8,0-1.6,0-2.4V16.393c.6.481,1.109.877,1.607,1.281.27.218.553.316.808.018.279-.327.1-.594-.18-.821-.771-.616-1.546-1.228-2.31-1.852a.6.6,0,0,0-.866,0c-.764.625-1.538,1.238-2.31,1.852-.284.226-.469.49-.195.819s.567.191.846-.035c.487-.4.98-.783,1.582-1.263",
    transform: "translate(0 0)",
    fill: "#003883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/upload-image-icon.9e6c28bd97c3c5097b0659679e39174e.svg";
export { ForwardRef as ReactComponent };